import { useQuery } from 'react-query';
import {
  getCastRelationships,
  type CastRelationshipsResponse
} from '../../services/castRelationshipService';

export function useGetCastRelationships({
  page,
  perPage,
  enabled = true
}: {
  page: number;
  perPage: number;
  enabled?: boolean;
}) {
  return useQuery<CastRelationshipsResponse>(
    ['castRelationships'],
    () => getCastRelationships({ page, perPage }),
    { enabled }
  );
}
